import {QueryKeys} from '../../../queryDefaults/QueryKeys';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import {AppMedError} from '../../../error/AppMedError.ts';
import {ITestKitOrderPayload} from '../TestKitOrder.ts';
import {TestKitOrderApi} from '../../../apis/TestKitOrderApi/TestKitOrderApi.ts';

export function usePostTestKitOrder() {
    const queryClient = useQueryClient();

    return useMutation<number, AppMedError, ITestKitOrderPayload>({
        mutationKey: [QueryKeys.testkitorder],
        mutationFn: async (variables: ITestKitOrderPayload) => {
            return await TestKitOrderApi.postTestKitOrder(variables);
        },
        onSuccess: async (code: number) => {
            queryClient.setQueryData<number>([QueryKeys.testkitorder], () => {
                return code;
            });
        },
    });
}